import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
/**
 * Switch + label laid out like the Figma "Switch": the 33×20 track sits flush with the left edge
 * of its box, the label starts 9px after it, and the label is body2 (14/22).
 */
export const DesignSwitch = ({ label, checked, onChange, disabled, }) => (React.createElement(FormControlLabel, { label: label, disabled: disabled, control: React.createElement(Switch, { checked: checked, onChange: (event) => onChange(event.target.checked) }), slotProps: { typography: { variant: "body2", color: "text.primary" } }, sx: {
        // The theme's switch has 12px of left padding and 13px on the right; trim both.
        m: 0,
        ml: "-12px",
        "& .MuiFormControlLabel-label": { ml: "-4px" },
    } }));
export default DesignSwitch;
